<template>
  <div class="bg-white flex flex-col w-full">
    <div class="bg-grey-lighter border p-2 flex items-center" v-if="mode === 'edit'">
      <label>Video URL:</label>
      <input type="url" v-model.lazy="content" class="border px-3 py-2 ml-2 flex-1" />
    </div>

    <div v-if="content" class="container mx-auto p-3">
      <div class="flex justify-center">
        <iframe :src="content" class="aspect-video rounded-lg overflow-hidden w-full" loading="lazy" :style="{maxWidth: '1280px'}" />
      </div>
    </div>
    <div v-else-if="mode === 'edit'" class="p-6">
      <i class="fas fa-video"></i> No video provided.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    mode: String
  },
  computed: {
    content: {
      get () {
        return this.value.url
      },
      set (value) {
        // Convert to embed links where possible
        let matches = value.match(/^https?:\/\/(?:www.)?(?:youtu.be\/|youtube.com\/watch\?.*v=)([a-zA-z0-9_-]+)/i)
        if (matches) {
          value = `https://www.youtube.com/embed/${matches[1]}`
        }

        matches = value.match(/^https?:\/\/(?:www.|player.)?vimeo.com(?:\/.*\/review|\/.*\/download|\/video|\/external)?\/(\d*)/i)
        if (matches) {
          value = `https://player.vimeo.com/video/${matches[1]}`
        }

        this.$emit('input', {
          url: value
        })
      }
    }
  }
}
</script>
